module.exports = __webpack_public_path__ + "img/icon-bitbox.3c28f39d.svg";